/////////////////////////////////////////////
// EXPERT-WRITTEN & FACT-CHECKED BUTTON
/////////////////////////////////////////////

if (window.location.href === 'https://www.dna-lean.co.uk/blogs/news') {
  window.location = 'https://www.dna-lean.co.uk/a/blog'
} else {
};

// CREATE THE BUTTON
var node = document.createElement("BUTTON");

// CREATE THE BUTTON TEXT
var textnode = document.createTextNode("Expert-written and fact-checked");

// APPEND THE TEXT TO THE BUTTON
node.appendChild(textnode);
node.classList.add('fact-checked');
node.classList.add('d-block');
node.classList.add('btn-sm');
node.classList.add('mt-2');
node.setAttribute('data-toggle', 'modal');
node.setAttribute('data-target', '#factChecked');

// APPEND THE BUTTON TO THE AUTHOR META SECTION ON THE BLOG
var c = document.getElementById("dib-post-single").children;
c[2].appendChild(node);

